import React, { useEffect, useState } from "react";
import '../../assets/styles/local/WorkflowAutomation.css'
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import { Col, Row } from 'react-bootstrap';
import closeIcon from "../../assets/icons/x-circle.svg";
import TipIcon from "../../assets/icons/Tip.png";
import AppDatePicker from '../Common/AppDatePicker';

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { Height } from "@mui/icons-material";



const DateSelector = ({ value, onChange, displayLabel }) => {


    const ENUM_OPTION_DATES = 'Dates'
    const ENUM_OPTION_SYSTEM = 'System'

    const [showDialog, setShowDialog] = useState(false);
    // const [option, setOption] = useState(ENUM_OPTION_DATES);

    // const [systemDates, setSystemDates] = useState([
    //     {
    //         id: 0,
    //         value: "Project's Start Date"
    //     },
    //     {
    //         id: 1,
    //         value: "1 Day after"
    //     },
    //     {
    //         id: 2,
    //         value: "Test 1"
    //     },
    //     {
    //         id: 3,
    //         value: "Test 1"
    //     },
    //     {
    //         id: 4,
    //         value: "Test 1"
    //     },
    //     {
    //         id: 5,
    //         value: "Test 1"
    //     },
    //     {
    //         id: 6,
    //         value: "Test 1"
    //     },
    // ])

    // const selectDate = (dateValue) => {
    //     let date = new Date(dateValue);
    //     onChange(date.toLocaleDateString())
    //     setShowDialog(false)
    // }

    // const selectSystemDate = (dateValue) => {
    //     onChange(dateValue)
    //     setShowDialog(false)
    // }

    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#FFFFFF",
            color: "grey",
            width: theme.typography.pxToRem(160),
            height: theme.typography.pxToRem(30),
            fontSize: theme.typography.pxToRem(12),
            fontSize: 10,
            boxShadow: theme.shadows[2],
            textAlign: "center", 
            lineHeight: "2",
        },
    }));

    const AttentionTooltipComponent = React.forwardRef(
        function AttentionTooltipComponent(props, ref) {
          return <img src={TipIcon} {...props} ref={ref} />;
        }
      );

    return (
        <>
            <div onClick={() => { setShowDialog(true) }} className="date-selector-calender-icon">
                <img
                    src={Calendericon}
                    alt="calender"
                    className="workflowDate"
                />
                &nbsp;&nbsp;
                {displayLabel} &nbsp;+&nbsp;&nbsp;
                <input type="number" name="quantity" value={value} className='custom-date-number' min="0" max="365" onChange={(e) => { onChange(e.target.value)}}/>

                <HtmlTooltip
                    placement="top"
                    title={
                        <React.Fragment>
                            <div>
                                <label>A number between 0 and 365</label>
                            </div>
                        </React.Fragment>
                    }>
                    <AttentionTooltipComponent className={"custom-date-number-tooltip"}/>
                </HtmlTooltip>

                {/* <img
                    src={TipIcon}
                    alt="Tip"
                    className='custom-date-number-tooltip'
                /> */}
            </div>

            {/* {showDialog &&
                <div className='date-selector'>
                    <Row>
                        <Col>
                            <div className='d-flex date-type-selection'>
                                <div className={option === ENUM_OPTION_DATES ? 'selected' : ''}
                                    onClick={() => {
                                        setOption(ENUM_OPTION_DATES)
                                    }}
                                >
                                    {ENUM_OPTION_DATES}
                                </div>
                                <div className={option === ENUM_OPTION_SYSTEM ? 'selected' : ''}
                                    onClick={() => {
                                        setOption(ENUM_OPTION_SYSTEM)
                                    }}
                                >
                                    {ENUM_OPTION_SYSTEM}
                                </div>
                            </div>
                        </Col>
                        <Col xl={2}>
                            <img className="cursor-pointer close-btn" src={closeIcon} alt=""
                                onClick={() => {
                                    setShowDialog(false);
                                }}
                            />
                        </Col>
                    </Row>

                    <div className='selctor-content '>
                        {option === ENUM_OPTION_DATES &&
                            <AppDatePicker
                                inputClassNames="hide"
                                dateFormat="dd/MM/yyyy"
                                open={true}
                                placeholderText="dd/mm/yyyy"
                                onChange={selectDate}
                                // selected={}
                            />
                        }
                        {option === ENUM_OPTION_SYSTEM && systemDates.length > 0 &&
                            <div className='system-date-section'>
                                {systemDates.map((o) => {
                                    return (
                                        <div className='item' key={o.id}>
                                            <input className='item-checkbox' type="checkbox"  value={o.value} onClick={() => { selectSystemDate(o.value)}}/>
                                            {o.value}
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>

                </div>
            } */}
        </>
    )
}

export default DateSelector